import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  language: 'en',
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action?.payload ?? 'en';
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
